// import Loadable from "app/components/Loadable";
import Loadable from "app/components/Loadable";
import { lazy } from "react";

const DealerList = Loadable(lazy(() => import("./DealerList")));
const DealerForm = Loadable(lazy(() => import("./DealerForm")));

const dealerRoutes = [
  {
    path: "/Dealer/DealerList",
    element: <DealerList />,
  },
  {
    path: "/Dealer/DealerForm",
    element: <DealerForm />,
  },
  {
    path: "/Dealer/DealerForm/:dealerId",
    element: <DealerForm />,
  },
];
export default dealerRoutes;
